import React from 'react';

import OverviewNavigationPanel from '@components/overview-navigation-panel/OverviewNavigationPanel';

import { CreditCards, DebitCards, RelatedCards } from './components';

import './MyCardsPage.scss';

const MyCardsPage = () => (
    <div className="sgw-layout seven-four-container">
        <div className="sgw-layout-item seven">
            <div className="sgw-layout-item my-cards">
                <DebitCards />
                <CreditCards />
                <RelatedCards />
            </div>
        </div>
        <div className="sgw-layout-item four">
            <div className="sgw-layout-item">
                <OverviewNavigationPanel />
            </div>
        </div>
    </div>
);

export default MyCardsPage;
